// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.inline-input[data-v-35f54da8] {\n    background: rgba(0, 0, 0, 0);\n    border: none;\n    color: white;\n    width: 150px;\n}\n", ""]);
// Exports
module.exports = exports;
